module.exports = __webpack_public_path__ + "img/eye-icon-disabled.2640d381.svg";